// @flow
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { Children, forwardRef, type Node } from 'react';
import classnames from 'classnames';

type Props = {
  children: Node,
  className?: string,
  hasControls: boolean,
  isSwiping?: boolean,
  itemPercentSize: number,
  onSwipeEnd?: () => void,
  onSwipeMove?: () => void,
  onSwipeStart?: () => void,
  position: number,
};

// $FlowFixMe
export const SliderHandlerItems = forwardRef((props: Props, ref: *) => {
  const {
    children,
    className,
    hasControls,
    isSwiping,
    itemPercentSize,
    onSwipeEnd,
    onSwipeMove,
    onSwipeStart,
    position,
  } = props;

  return (
    <div
      className={classnames(className, 'overflow-hidden')}
      ref={ref}
      tabIndex={hasControls ? 0 : -1}
    >
      <div
        className={classnames('flex h-full will-change-transform', {
          'transition-transform': !isSwiping,
        })}
        style={{ transform: `translate(${position}%, 0)` }}
        onTouchStart={onSwipeStart}
        onTouchMove={onSwipeMove}
        onTouchEnd={onSwipeEnd}
      >
        {Children.map(children, (child, idx) => (
          <div
            className="max-w-full image-responsive-cell will-change-transform"
            key={idx}
            style={{ minWidth: `${itemPercentSize}%`, maxWidth: `${itemPercentSize}%` }}
          >
            {child}
          </div>
        ))}
      </div>
    </div>
  );
});
